// FETCH
export const FETCH_DAILY_RECORDS = "app/DAILY_RECORDS/FETCH_DAILY_RECORDS";
export const FETCH_DAILY_RECORDS_SUCCESS =
  "app/DAILY_RECORDS/FETCH_DAILY_RECORDS_SUCCESS";
export const FETCH_DAILY_RECORDS_FAILURE =
  "app/DAILY_RECORDS/FETCH_DAILY_RECORDS_FAILURE";
